import { render, staticRenderFns } from "./law.vue?vue&type=template&id=07bbce5a&scoped=true&lang=pug&"
var script = {}
import style0 from "./law.vue?vue&type=style&index=0&id=07bbce5a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bbce5a",
  null
  
)

export default component.exports